import { render, staticRenderFns } from "./Creditnote.vue?vue&type=template&id=16bd1364&"
import script from "./Creditnote.vue?vue&type=script&lang=js&"
export * from "./Creditnote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports